import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'

import slugify from 'react-slugify'
import SelectTags from '../SelectTags'

import Context from '../../context'

import {
  getAmenitiesList,
  getEventsPlacesList,
  getEventsProducerList,
  getParentalRatingList
} from '../../services/ClubeApi'
import CreateEventPlaceModal from '../CreateEventPlaceModal'
import CreateProducerModal from '../CreateProducerModal'
import ProgressBar from '../ProgressBar'
import SlugSeoDescription from '../SlugSeoDescription'
import TextAreaHtml from '../TextAreaHtml'

function EventData({ checkValue, checkIsRed }) {
  const {
    formObject,
    setFormObject,
    selectedAmenitiesOnEdit,
    setOpenProducerModal,
    setOpenPlaceModal
  } = useContext(Context)
  const [amenitiesList, setAmenitiesList] = useState([])
  const [parentalRatingList, setParentalRatingList] = useState([])
  const [producerList, setProducerList] = useState([])
  const [placesList, setPlacesList] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const updateProducerList = () => {
    getEventsProducerList().then(r => {
      const newArr = r.filter(item => {
        return item.situation === 1
      })
      setProducerList([...newArr])
    })
  }

  const updatePlacesList = () => {
    getEventsPlacesList().then(r => {
      const newArr = r.filter(item => {
        return item.situation === 1
      })
      setPlacesList([...newArr])
    })
  }

  useEffect(() => {
    updateProducerList()
    updatePlacesList()

    getParentalRatingList().then(r => {
      const newArr = r.filter(item => {
        return item.situation === 1
      })
      setParentalRatingList([...newArr])
    })

    getAmenitiesList().then(r => {
      const newArr = r.map(item => {
        return { ...item, selected: selectedAmenitiesOnEdit.includes(item.id) }
      })
      setAmenitiesList([...newArr])
      setIsLoading(false)
    })
  }, [selectedAmenitiesOnEdit])

  useEffect(() => {
    setFormObject(formObject => ({
      ...formObject,
      EventAmenities: amenitiesList
    }))
  }, [amenitiesList])

  useEffect(() => {
    const newArr = amenitiesList
      .filter(item => {
        return selectedAmenitiesOnEdit.includes(item.id)
      })
      .map(item => {
        return { ...item, selected: true }
      })
    setAmenitiesList([...amenitiesList, ...newArr])
  }, [selectedAmenitiesOnEdit])

  useEffect(() => {
    const seoDescription = `Saiba mais sobre o ${formObject.name} e aproveite os descontos do Clube Gazeta do Povo!`
    setFormObject(formObject => ({ ...formObject, seoDescription }))
  }, [formObject.name])

  useEffect(() => {
    const newArr = amenitiesList
      .filter(item => {
        return item.selected
      })
      .map(item => {
        return { amenitiesId: item.id }
      })
    setFormObject(formObject => ({
      ...formObject,
      eventsAmenities: [...newArr]
    }))
  }, [amenitiesList])

  const handleAmenity = id => {
    const newArr = amenitiesList.map(item => {
      if (item.id === id) {
        return { ...item, selected: !item.selected }
      }
      return { ...item }
    })
    setAmenitiesList([...newArr])
  }

  const onBlurName = () => {
    setFormObject(formObject => ({
      ...formObject,
      slug: slugify(`${formObject.name}`)
    }))

    checkValue('name', formObject.name)
  }

  const handleTextArea = value => {
    setFormObject(formObject => ({ ...formObject, description: value }))
  }

  return (
    <>
      {isLoading ? (
        <ProgressBar marginTop="30px" height="30px" />
      ) : (
        <>
          <h6>Dados do Evento</h6>
          <div className="row">
            <SelectTags categoryType="categoryEvents" />
          </div>
          <div className="row">
            <div className="form-group col-md-12">
              <input
                type="text"
                className={`form-control ${checkIsRed('name') && 'clube-border-danger'}`}
                placeholder="Nome do Evento"
                value={formObject.name}
                onChange={e =>
                  setFormObject({
                    ...formObject,
                    name: e.target.value
                  })
                }
                onBlur={onBlurName}
              />
            </div>

            <div className="form-group col-6 d-flex flex-row">
              <div style={{ paddingRight: 5 }} className="flex-grow-1">
                <select
                  className="form-control"
                  name="local"
                  value={formObject.place}
                  onChange={e =>
                    setFormObject({
                      ...formObject,
                      place: e.target.value
                    })
                  }
                >
                  <option value={0}>Local do Evento</option>
                  {placesList.map(place => (
                    <option key={place.id} value={place.id}>
                      {place.name}
                    </option>
                  ))}
                </select>
              </div>
              <div style={{ paddingLeft: 5 }}>
                <button
                  type="button"
                  className="btn clube-blue"
                  onClick={() => setOpenPlaceModal(true)}
                >
                  Criar Local
                </button>
              </div>
            </div>
            <div className="form-group col-6">
              <select
                className="form-control"
                onChange={e =>
                  setFormObject({
                    ...formObject,
                    parentalRating: e.target.value
                  })
                }
                value={formObject.parentalRating || ''}
              >
                <option value={0}>Classificação Indicativa</option>
                {parentalRatingList.map(item => (
                  <option
                    key={item.id}
                    defaultValue={formObject.parentalRating === item.id}
                    value={item.id}
                  >
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group col-12 flex-row d-flex">
              <div style={{ paddingRight: 5 }} className="flex-grow-1">
                <select
                  onChange={e =>
                    setFormObject({
                      ...formObject,
                      producer: e.target.value
                    })
                  }
                  value={formObject.producer}
                  className="form-control"
                  name="local"
                >
                  <option value={0}>Selecione a Produtora</option>
                  {producerList.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
              <div style={{ paddingLeft: 5 }}>
                <button
                  type="button"
                  className="btn clube-blue"
                  onClick={() => setOpenProducerModal(true)}
                >
                  Criar Produtora
                </button>
              </div>
            </div>
            <div className="col-12">
              <SlugSeoDescription checkValue={checkValue} checkIsRed={checkIsRed} />
            </div>
            <div className="col-12">
              <div className="row">
                {amenitiesList.map(amenity => (
                  <div key={`${amenity.id}`} className="col">
                    <div className="form-check form-group align-items-center">
                      <input
                        checked={amenity.selected}
                        onChange={() => handleAmenity(amenity.id)}
                        className="form-check-input"
                        type="checkbox"
                        id={amenity.id}
                      />
                      <label htmlFor={amenity.id} className="form-check-label">
                        {amenity.name}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <TextAreaHtml
              handleEditor={handleTextArea}
              placeholder="Informações gerais sobre o evento."
              value={formObject.description}
            />
          </div>
          <CreateProducerModal updateProducerList={updateProducerList} />
          <CreateEventPlaceModal updatePlacesList={updatePlacesList} />
        </>
      )}
    </>
  )
}

EventData.defaultProps = {
  checkValue: () => {},
  checkIsRed: () => {}
}

EventData.propTypes = {
  checkValue: PropTypes.func,
  checkIsRed: PropTypes.func
}

export default EventData
